import moment from 'moment-timezone'

export function random (min, max) {
  return Math.floor(Math.random() * (max - min + 1) + min)
}

export function randomString(length) {
  let result = '';
  const characters = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz';
  const charactersLength = characters.length;
  let counter = 0;
  while (counter < length) {
    result += characters.charAt(Math.floor(Math.random() * charactersLength));
    counter += 1;
  }
  return result;
}

/**
 * Randomize array element order in-place.
 * Using Durstenfeld shuffle algorithm.
 */
export const shuffleArray = (array) => {
  for (let i = array.length - 1; i > 0; i--) {
    let j = Math.floor(Math.random() * (i + 1))
    let temp = array[i]
    array[i] = array[j]
    array[j] = temp
  }
  return array
}

export function can(permission) {
  if (this.$store.getters.isAdmin) return true
  
  if (this.$store.getters.permissions) {
    return this.$store.getters.permissions.find(perm => {
      return permission.toLowerCase() == perm
    }) !== undefined
  }

  return false
}

export function isAdmin() {
  return this.$store.getters.isAdmin
}

export function isProjectOwner() {
  return this.$store.getters.getCurrentProject.user_uuid == this.$store.getters.getUser.uuid
}

export function deepCopyObject(obj) {
  return JSON.parse(JSON.stringify(obj))
}

export function toUserTimeZone(time) {
  if (time == null) return null;
  
  let format = 'YYYY-MM-DD HH:mm:ss';
  let user = this.$store.getters.getUser;
  let zone = user.settings.timezone;

  if (zone === null || zone === undefined || zone == "") {
    return moment(time).tz(moment.tz.guess()).format(format);
  }

  return moment(time).tz(zone).format(format);
}

export function debugLog(...data) {
  if (this.$env.get('MODE') != "production") {
    console.error(data)
  }
}

export function loaderPopup(text) {
  let loader = this.$loading.show({
    // Pass props by their camelCased names
    color: '#fff',
    loader: 'spinner',
    width: 64,
    height: 64,
    backgroundColor: '#2C3135',
    opacity: 0.7,
    zIndex: 9999,
    isFullPage: true,
    
  }, {
    // Pass slots by their names
    before: this.$createElement('p', text),
})

  return loader
}


export function isPlatformEnv(env) {
  return this.$store.getters.getCurrentEnv == env
}

export function translateLabel(label, d) {
  try {
    let translated = label.locales[this.$store.getters.getLocale]
    if (Object.keys(label.locales).length == 1) {
      translated = label.locales[Object.keys(label.locales)[0]]
    }

    if (translated == null || translated == "") {
      return d
    }

    return translated
  } catch(err) {
    //console.warn(`Failed to translate label ${label}:  ${err.message}. Settings default value ${d}.`)
    return d
  }
}

export function pageUnavailable() {
  this.$router.push({query: {pageUnavailable:true}})
}

export function deleteConfirmationPrompt() {
  return new Promise((resolve, reject) => {
    const h = this.$createElement
      // Using HTML string
      var value

      const messageVNode = h('div', {}, [
        h('p', { class: ['text-center'] }, this.$t('ifYouWantToDeleteThisItem')),
        h('b-input', {
          props: {
            autofocus: true
          },
          on: {
            input: (e) => {
              value = e
            }
          }
        })
      ])
      
      this.$bvModal.msgBoxConfirm([messageVNode], {
        hideHeader: true,
        okTitle: this.$t('confirm'),
        okVariant: 'danger',
        buttonSize: 'sm',
        cancelTitle: this.$t('cancel'),
        centered: true,
        size: 'sm',
      }).then((confirmed) => {
        resolve(value == 'delete' && confirmed)
      })
  })
}